import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { IApiResponse } from "../../../utils/types/api-response";
import { INoteAccessOverride } from "../types/note-access-overrides.types";
import { fetchNoteAccessOverrides } from "../services/note-access-overrides.services";

export function useFetchNoteAccessOverrides() {
    return useQuery<
        IApiResponse<INoteAccessOverride>,
        AxiosError<IApiResponse<INoteAccessOverride>>
    >({
        queryKey: ["note-access-overrides"],
        queryFn: () => fetchNoteAccessOverrides(),
    });
}
